import {ImageURL, LobbyImage} from '@colonist/types'
import {createDivIn, createExternalImgIn} from '../../ui_utils/DomUtils'
import {UIImagePathController} from '../../UIEnums.ts'
import {TranslationObject} from '@colonist/i18n'
import {PlayerColor} from '@colonist/game-states'
import {GameClientUserState} from '@colonist/game-base-types'
import {createTooltipIn} from '../../ui_utils/TooltipUtils.ts'

export class UIReplayAvatarView {
    private readonly container: HTMLDivElement
    private readonly avatar: LobbyImage
    private readonly userState: GameClientUserState
    readonly playerColor: PlayerColor

    private iconContainer: HTMLDivElement
    private readonly tooltip: TranslationObject

    constructor(container: HTMLDivElement, avatar: LobbyImage, playerColor: PlayerColor, tooltip: TranslationObject, userState: GameClientUserState) {
        this.container = container
        this.avatar = avatar
        this.playerColor = playerColor
        this.tooltip = tooltip
        this.userState = userState
        this.createPlayerAvatar()
    }

    setUnfocused(unfocused: boolean) {
        this.iconContainer.classList.toggle('replay-avatar-player-unfocused', unfocused)
    }

    setAction(action: () => void) {
        this.iconContainer.onclick = action
    }

    private createPlayerAvatar() {
        this.iconContainer = createDivIn(this.container, 'replay-avatar-player')
        createTooltipIn(this.iconContainer, this.tooltip)
        this.iconContainer.style.backgroundImage = `url('${UIImagePathController.playerBackgroundByColor[this.playerColor]}')`

        this.createPlayerIcon(this.iconContainer)
    }

    private createPlayerIcon(container: HTMLDivElement) {
        const iconClass = 'replay-avatar-player-icon'
        const iconSrc = UIImagePathController.getImgPath(this.avatar)

        if(this.userState.profilePictureUrl != undefined) {
            UIReplayAvatarView.createPlayerProfilePicture(container, this.userState.profilePictureUrl)
            return
        }

        const playerIcon = createExternalImgIn(container, iconSrc, {key: 'strings:colonistCommon.utils.emptyString'}, iconClass)
        if(this.userState.isBot) playerIcon.classList.add('replay-avatar-player-icon-bot')
    }

    private static createPlayerProfilePicture(container: HTMLDivElement, profilePictureUrl: ImageURL) {
        const iconClass = 'replay-avatar-player-icon replay-avatar-player-profile-picture'
        createExternalImgIn(container, profilePictureUrl, {key: 'strings:colonistCommon.utils.emptyString'}, iconClass)
    }
}
